import { ButtonTypes } from '~/components/Button';
import FormSection, { Column, InputContainer, Row } from '~/components/FormSection/FormSection';
import { SelectField } from '~/components/Select';
import options from '~/components/Select/options';
import SubmitButton from '~/components/SubmitButton/SubmitButton';
import * as React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import { getDefaultDistanceUnit, getDefaultWeightUnit } from '~/selectors/packages.selectors';
import { distanceOptionsBuilder, weightOptionsBuilder } from '~/utils/packages';
import { ApplicationState } from '../../../store';

class DefaultPackageUnitsForm extends React.Component<
  InjectedFormProps & DefaultPackageUnitsFormStateProps
> {
  componentDidUpdate(prevProps) {
    if (!this.props.anyTouched) {
      if (prevProps.defaultWeightUnit !== this.props.defaultWeightUnit) {
        this.props.change(
          'defaultWeightUnit',
          options.commonWeightOptions[this.props.defaultWeightUnit],
        );
      }
      if (prevProps.defaultDistanceUnit !== this.props.defaultDistanceUnit) {
        this.props.change(
          'defaultDistanceUnit',
          options.commonDistanceOptions[this.props.defaultDistanceUnit],
        );
      }
    }
  }

  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <FormSection>
          <Row>
            <Column width="100%">
              <InputContainer>
                <Field
                  name="defaultWeightUnit"
                  component={SelectField}
                  size="100%"
                  label="Default weight unit"
                  options={weightOptionsBuilder()}
                />
              </InputContainer>
              <InputContainer>
                <Field
                  style={{ minWidth: '100%' }}
                  name="defaultDistanceUnit"
                  component={SelectField}
                  size="100%"
                  label="Default dimension unit"
                  options={distanceOptionsBuilder()}
                />
              </InputContainer>
              {/*Hiding until this is implemented in the label flows*/}
              {/*<Field*/}
              {/*name="is_use_imported_orders_weight"*/}
              {/*component={CheckboxField}*/}
              {/*label="Use imported order weight in label purchase"*/}
              {/*/>*/}
              <div>
                <SubmitButton
                  type="submit"
                  buttonType={ButtonTypes.Primary}
                  submittedSuccess={this.props.submitSucceeded}
                  submitting={this.props.submitting}
                  preSubmitText="Save"
                  successSubmitText="Saved"
                />
              </div>
            </Column>
          </Row>
        </FormSection>
      </form>
    );
  }
}

interface DefaultPackageUnitsFormStateProps {
  defaultWeightUnit: string;
  defaultDistanceUnit: string;
}

const mapStateToProps = (state: ApplicationState) => {
  return {
    defaultWeightUnit: getDefaultWeightUnit(state),
    defaultDistanceUnit: getDefaultDistanceUnit(state),
  };
};

export const DEFAULT_PACKAGE_UNITS_FORM = 'DEFAULT_PACKAGE_UNITS_FORM';

const ComposedDefaultPackageUnitsForm =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  compose<any>(
    reduxForm({ form: DEFAULT_PACKAGE_UNITS_FORM }),
    connect(mapStateToProps),
  )(DefaultPackageUnitsForm);

export default ComposedDefaultPackageUnitsForm;
